
import { defineComponent, PropType, onMounted, reactive, Ref, ref, toRefs } from "vue";
import $api from "@/api/main";
export default defineComponent({
   props: {
      visible: {
         type: Boolean,
         default: true,
      },

      /**
       * 外部定义树的数据
       */
      tree: {
         type: Array as PropType<any[]>,
         default: (): any => [],
      },

      /**
       *
       */
      extTree: {
         type: Boolean,
         default: false,
      },

      /**
       *
       */
      expand: {
         type: String as PropType<string>,
         default: "",
      },

      pathTable: {
         type: Object,
         default: (): any => {
            return {};
         },
      },
   },
   setup(props, ctx) {
      const propsData: any = reactive(props);
      const cascader: Ref<null> = ref(null);
      const data = reactive({
         tree: [],
      });

      const change = (expand: string) => {
         if (propsData.pathTable[expand].selectable == true) {
            ctx.emit("update:expand", expand);
            ctx.emit("update:visible", false);
         }
      };

      /**
       * 获取员工树
       */
      const getStaffTree = async () => {
         data.tree = await $api.getStaffTree();
      };

      onMounted(() => {
         if (!propsData.extTree) {
            getStaffTree();
         }
      });

      return {
         data,
         cascader,
         change,
      };
   },
});
